import React, { useContext, useEffect, useState } from "react";
import { Tooltip, Typography } from "antd";
import { Button, Offcanvas, Tabs, Tab } from "react-bootstrap";
import SmartAssistProbing from "./components/SmartAssistProbing";
import CustomerCard from "./components/CustomerCard";
import { CustomerProps } from "../ShowCustomer";
import CallDisposition from "./components/CallDisposition";
import { useSmartAssistStore } from "./store";

const { Title } = Typography;

function SmartAssist() {
  const [show, setShow] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const {
    fetchPreReadSmartAssist,
    fetchSmartAssistIssues,
    resetToDefaultState,
    previousCxId,
    setPreviousCxId
  } = useSmartAssistStore();

  const { customer } = useContext(CustomerProps);

  const handleClose = () => setShow(false);

  const handleShow = () => {
    setShow(true);

    if (customer?.id && customer.id !== previousCxId) {
      resetToDefaultState();
      fetchSmartAssistIssues(customer.id);
      fetchPreReadSmartAssist(customer.id);
      setPreviousCxId(customer.id);
    }
  };

  return (
    <>
      <Tooltip title="Get Assistant from AI">
        <Button variant="primary" className="py-2 me-2" onClick={handleShow}>
          Smart Assist
        </Button>
      </Tooltip>

      <Offcanvas
        placement="end"
        name="smart-assist"
        show={show}
        onHide={handleClose}
        style={{ width: "70%" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="m-0">
            <Title level={3} className="text-primary fw-bolder m-0">Smart Assist</Title>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0">
          <Tabs
            id="offcanvas-tabs"
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-3"
          >
            <Tab eventKey="1" title="Pre Read">
              <div className="d-flex flex-column gap-3 mx-4">
                <CustomerCard />
                <CallDisposition />
              </div>
            </Tab>

            <Tab eventKey="2" title="Assist">
              <div className="mx-4">
                <SmartAssistProbing />
              </div>
            </Tab>
          </Tabs>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default SmartAssist;
